/*
	* Handles state needed to manage Mapbox Layers: which layers are visible, paint properties, etc
	*
 */

import {
	_updateMapStyleOnVisibilityChange,
	_updateURLWithCurrentState
} from "./mapActions";
import {getRuralFilterOptionIndexFromStringSelector, selectedRuralDefinitionSelector} from "../selectors";


// Action Object creators:
// - do nothing but return action objects
// - are named as commands describing what should be done (not how it's done)

export const CHANGE_RURAL_DEFINITION_ACTION = 'CHANGE_RURAL_DEFINITION_ACTION'
const changeRuralDefinitionAction = (newSelectedRuralDefinition) => ({
	type: CHANGE_RURAL_DEFINITION_ACTION,
	newSelectedRuralDefinition,
})

export const ADD_A_RURAL_DEFINITION_FILTER_OPTION = 'ADD_A_RURAL_DEFINITION_FILTER_OPTION'
const addARuralDefinitionFilterOptionAction = (filterOptionIndex) => ({
	type: ADD_A_RURAL_DEFINITION_FILTER_OPTION,
	newFilterOptionIndex: filterOptionIndex,
})

export const REMOVE_A_RURAL_DEFINITION_FILTER_OPTION = 'REMOVE_A_RURAL_DEFINITION_FILTER_OPTION'
const removeARuralDefinitionFilterOptionAction = (filterOptionIndex) => ({
	type: REMOVE_A_RURAL_DEFINITION_FILTER_OPTION,
	removedFilterOptionIndex: filterOptionIndex,
})

export const INITIALIZE_CARTO_LAYERS_FROM_URL = 'INITIALIZE_CARTO_LAYERS_FROM_URL'
const initializeMapboxLayersFromURLAction = (mapboxLayersFromURL) => ({
	type: INITIALIZE_CARTO_LAYERS_FROM_URL,
	mapboxLayersFromURL,
})


// Helpers


// Actions used by UI:
// - are named as commands describing what should be done (not how it's done)
// - when asynchronous, return a Promise so UI can .then() method-chain if needed.
// - return a function which takes a dispatch (to redux state) function and optionally getReduxState
// - handle all logic and caching/cache reading, often dispatching multiple actions in the process

export const changeRuralPresetDefinition = (newRuralDefinition) => {
	return (dispatch, getReduxState) => {
		dispatch(changeRuralDefinitionAction(newRuralDefinition))
		dispatch(_updateMapStyleOnVisibilityChange())
		dispatch(_updateURLWithCurrentState())
	}
}

export const changeRuralDefinition = (newSelectedRuralDefinition) => {
	return (dispatch, getReduxState) => {
		dispatch(changeRuralDefinitionAction(newSelectedRuralDefinition))
		dispatch(_updateMapStyleOnVisibilityChange())
		dispatch(_updateURLWithCurrentState())
	}
}

export const addARuralDefinitionFilterOption = (filterOptionString) => {
	return (dispatch, getReduxState) => {
		const reduxState = getReduxState()
		const selectedRuralDefinition = selectedRuralDefinitionSelector(reduxState)
		dispatch(addARuralDefinitionFilterOptionAction(getRuralFilterOptionIndexFromStringSelector(selectedRuralDefinition, filterOptionString)))
		dispatch(_updateMapStyleOnVisibilityChange())
		dispatch(_updateURLWithCurrentState())
	}
}

export const removeARuralDefinitionFilterOption = (filterOptionString) => {
	return (dispatch, getReduxState) => {
		const reduxState = getReduxState()
		const selectedRuralDefinition = selectedRuralDefinitionSelector(reduxState)
		const filterOptionIndex = getRuralFilterOptionIndexFromStringSelector(selectedRuralDefinition, filterOptionString)
		dispatch(removeARuralDefinitionFilterOptionAction(filterOptionIndex))
		dispatch(_updateMapStyleOnVisibilityChange())
		dispatch(_updateURLWithCurrentState())
	}
}

export const initializeMapboxLayersFromURL = (mapboxLayersFromURL = null) => {
	return (dispatch, getReduxState) => {
		if (mapboxLayersFromURL) dispatch(initializeMapboxLayersFromURLAction(mapboxLayersFromURL))
	}
}
